import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Agenda = React.lazy(() => import("@mediaspace/features/agenda"));

export const render = getDsLayoutComponentRenderer(Agenda);
